module.exports = __webpack_public_path__ + "img/product_3.f3252083.png";